import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const CoinDetailsStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      color: "#7B858B",
      fontFamily: "Roobert",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "17px",
      display: "inline",
    },
    value: {
      color: "#002035",
      fontFamily: "Söhne",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "19px",
    },
    layout: {
      display: "flex",
      justifyContent: "space-evenly",
      borderRadius: "8px",
      background: "#F8F9F9",
    },
  }),
);
